import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M7.999 10.355C7.722 8.773 5.367 6.43 5.044 6.13A9.692 9.692 0 0 1 8 .39a9.692 9.692 0 0 1 2.955 5.742c-.323.3-2.678 2.643-2.955 4.224Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.94 15.606a8.546 8.546 0 0 1-5.854-3.113A8.43 8.43 0 0 1 .25 6.045 8.561 8.561 0 0 1 6.218 9.17 8.432 8.432 0 0 1 8 13.057 8.432 8.432 0 0 1 9.784 9.17a8.563 8.563 0 0 1 5.968-3.123 8.447 8.447 0 0 1-1.84 6.447 8.552 8.552 0 0 1-5.896 3.116H8.01c-.005.002-.009.002-.012.002l-.012-.001c-.015 0-.028-.002-.042-.003H7.94Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconInfrastructureSpa16 = createIcon(IconComponent);